<template>
  <div class="pos_container_panel" style="padding-left: 2rem;width: 90%;">
    <Loading :loading="submitLoading" />
    <!--add area-->
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" style="margin-left: 6rem; padding-top: 2rem">
      <el-row style="">
        <el-col :span="16">
          <div class="grid-content bg-purple">
            <el-form-item label="酒店code">
              <el-input v-model="searchForm.code" autocomplete="off"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light"></div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="float: right">
          <div class="grid-content bg-purple-light" style="float: right">
            <el-button type="warning" class="harpIDbtn" @click="customSearch()">
              搜索</el-button>
            <el-button type="warning" class="harpIDbtn" style="margin-left: 3rem" @click="addGroup()">
              新增
            </el-button>
            <!-- <el-button type="warning" class="harpIDbtn" @click="uploadFile" style="margin-left: 3rem">
              导入</el-button>
            <input type="file" @change="fileValueChange()" ref="uploadFile" enctype="multipart/form-data"
              id="import_btn" style="display: none" /> -->
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!--table-->
    <el-table :data="tableData" border style="width: 90%; margin-top: 50px; margin-left: 100px">
      <el-table-column prop="code" label="FXCode" align="center"></el-table-column>
      <el-table-column prop="cName" label="CWT集团名" align="center"></el-table-column>
      <el-table-column prop="eName" label="CWT集团名(EN)" align="center"></el-table-column>
      <!-- <el-table-column prop="remoteSystemCode" label="三方" align="center"></el-table-column> -->
      <!-- <el-table-column prop="remoteSystemGroupCode" label="三方集团编码" align="center"></el-table-column> -->
      <el-table-column prop="remoteSystemGroupCnName" label="FX集团名" align="center"></el-table-column>
      <el-table-column prop="remoteSystemGroupEnName" label="FX集团名(EN)" align="center"></el-table-column>
      <!-- <el-table-column prop="isIntegral" label="是否积分" align="center" :formatter="Format"></el-table-column> -->
      <el-table-column prop="createdDate" label="创建时间" align="center" :formatter="Format"></el-table-column>
      <el-table-column label="操作" width="132" align="center">
        <template #default="scope">
          <el-button @click="handleChange(scope.row)" type="text" size="small">修改</el-button>
          <el-button type="text" size="small" @click.prevent="deleteRow(scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-bottom: 1rem">
      <el-pagination class="paginationsty" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" v-model:current-page="currentPage1" :page-size="10"
        layout="total, prev, pager, next" :total="searchForm.total">
      </el-pagination>
    </div>
    <!--新增 dialog-->
    <el-dialog title="新增" v-model="dialogFormVisible" @close="closeaddDialog('form')">
      <div v-draggable>
      <el-form :model="form" ref="form">
        <el-form-item label="酒店集团Code:" :label-width="formLabelWidth" prop="Code" :rules="[
          {
            required: true,
            message: '请输入酒店集团Code',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="form.Code" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <el-form-item label="酒店集团名称-中文:" :label-width="formLabelWidth" prop="CName" :rules="[
          {
            required: true,
            message: '请输入酒店集团名称-中文',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="form.CName" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <el-form-item label="酒店集团名称-英文:" :label-width="formLabelWidth" prop="EName" :rules="[
          {
            required: true,
            message: '请输入酒店集团名称-英文',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="form.EName" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <!--三方-->
        <!-- <el-form-item label="三方Code:" :label-width="formLabelWidth" prop="RemoteSystemCode" :rules="[
          {
            required: true,
            message: '请输三方Code',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="form.RemoteSystemCode" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>         -->
        <!-- <el-form-item label="三方酒店集团Code:" :label-width="formLabelWidth" prop="RemoteSystemGroupCode" :rules="[
          {
            required: true,
            message: '请输入三方酒店集团Code',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="form.RemoteSystemGroupCode" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <el-form-item label="三方酒店集团-中文:" :label-width="formLabelWidth" prop="RemoteSystemGroupCnName" :rules="[
          {
            required: true,
            message: '请输入三方酒店集团-中文',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="form.RemoteSystemGroupCnName" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <el-form-item label="三方酒店集团-英文:" :label-width="formLabelWidth" prop="RemoteSystemGroupEnName" :rules="[
          {
            required: true,
            message: '请输入三方酒店集团-英文',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="form.RemoteSystemGroupEnName" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>         -->
        <!-- <el-form-item label="是否可积分:" :label-width="formLabelWidth" prop="isIntegral" :rules="[
          {
            required: true,
            message: '请选择是否可积分',
            trigger: 'blur',
          },
        ]">
          <el-radio-group v-model="form.isIntegral" style="margin-left: 85px">
            <el-radio label="true">是</el-radio>
            <el-radio label="false">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="dataSave()">保存</el-button>
          <el-button @click="cancel()">取 消</el-button>
        </div>
      </template>
    </el-dialog>
    <!--修改 dialog-->
    <el-dialog title="修改" v-model="changeCountryFlag" >
      <el-form :model="changeForm">
        <el-form-item label="酒店集团Code:" :label-width="formLabelWidth" prop="Code" :rules="[
          {
            required: true,
            message: '请输入酒店集团Code',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="changeForm.Code" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <el-form-item label="酒店集团名称-中文:" :label-width="formLabelWidth" prop="CName" :rules="[
          {
            required: true,
            message: '请输入酒店集团名称-中文',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="changeForm.CName" autocomplete="off" style="width: 58%; margin-left: 85px">
          </el-input>
        </el-form-item>
        <el-form-item label="酒店集团名称-英文:" :label-width="formLabelWidth" prop="EName" :rules="[
          {
            required: true,
            message: '请输入酒店集团名称-英文',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="changeForm.EName" autocomplete="off" style="width: 58%; margin-left: 85px">
          </el-input>
        </el-form-item>
        <!--三方-->
        <!-- <el-form-item label="三方Code:" :label-width="formLabelWidth" prop="RemoteSystemCode" :rules="[
          {
            required: true,
            message: '请输三方Code',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="changeForm.RemoteSystemCode" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>         -->
        <!-- <el-form-item label="三方酒店集团Code:" :label-width="formLabelWidth" prop="RemoteSystemGroupCode" :rules="[
          {
            required: true,
            message: '请输三方入酒店集团Code',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="changeForm.RemoteSystemGroupCode" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <el-form-item label="三方酒店集团-中文:" :label-width="formLabelWidth" prop="RemoteSystemGroupCnName" :rules="[
          {
            required: true,
            message: '请输入三方酒店集团-中文',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="changeForm.RemoteSystemGroupCnName" autocomplete="off" style="width: 58%; margin-left: 85px">
          </el-input>
        </el-form-item>
        <el-form-item label="三方酒店集团-英文:" :label-width="formLabelWidth" prop="RemoteSystemGroupEnName" :rules="[
          {
            required: true,
            message: '请输入三方酒店集团-英文',
            trigger: 'blur',
          },
        ]">
          <el-input v-model="changeForm.RemoteSystemGroupEnName" autocomplete="off" style="width: 58%; margin-left: 85px">
          </el-input>
        </el-form-item> -->
        <!-- <el-form-item label="是否可积分:" :label-width="formLabelWidth" prop="isIntegral" :rules="[
          {
            required: true,
            message: '请选择是否可积分',
            trigger: 'blur',
          },
        ]">
          <el-radio-group v-model="changeForm.isIntegral" style="margin-left: 85px">
            <el-radio label="true">是</el-radio>
            <el-radio label="false">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="changeSave()">保存</el-button>
          <el-button @click="cancel()">取 消</el-button>
        </div>
      </template>
    </el-dialog>
    <!--删除 dialog-->
    <el-dialog title="" v-model="deletedialogVisible" width="30%" >
      <span>请确认是否删除</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="confirmDelete">确 定</el-button>
          <el-button @click="cancelDelete">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <ConfirmBoxs :centerDialogVisible="confirmFlag" :confirmMsg="confirmMsg" :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"></ConfirmBoxs>
  </div>
</template>

<script>
import {
  groupList,
  groupSave,
  groupDelete,
  groupImport,
  sourceGroupList,
} from "@/api/shoppingData";
import Loading from "@/components/Loading.vue";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import {
  formatDateTime,
} from "@/utils/utils.js";
export default {
  name: "HBEGroup",
  components: {
    ConfirmBoxs,
    Loading,
  },
  data() {
    return {
      deletedialogVisible: false,
      deleteFlag: false,
      deleteparams: {},
      confirmFlag: false,
      changeRow: {},
      CountryCode: "",
      currentPage1: 1,
      form: {
        CName: "",
        EName: "",
        Code: "",
        RemoteSystemGroupCnName: "",
        RemoteSystemGroupEnName: "",
        RemoteSystemGroupCode: "",
        RemoteSystemCode: "FX",
        isIntegral: "true",
      },
      changeForm: {
        id: 0,
        CName: "",
        EName: "",
        Code: "",
        RemoteSystemGroupCnName: "",
        RemoteSystemGroupEnName: "",
        RemoteSystemGroupCode: "",
        RemoteSystemCode: "FX",
        isIntegral: "false",
      },
      //新增dialog
      confirmIcon: "",
      confirmMsg: "",
      dialogFormVisible: false,
      changeCountryFlag: false,
      formLabelWidth: "150px",
      tableData: [],
      searchForm: {
        code: "",
        total: 0,
      },
      isShow: true,
      submitLoading: false,
    };
  },
  mounted() {
    this.customSearch();
  },
  methods: {
    closeaddDialog(formRule) {
      console.log(formRule);
      this.$refs[formRule].resetFields();
    },
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.customSearch(val);
      console.log(`当前页: ${val}`);
    },

    addGroup() {
      this.dialogFormVisible = true;
    },
    //新增保存
    async dataSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let saveParams = {
            CName: this.form.CName,
            EName: this.form.EName,
            Code: this.form.Code,
            RemoteSystemGroupCnName: this.form.RemoteSystemGroupCnName,
            RemoteSystemGroupEnName: this.form.RemoteSystemGroupEnName,
            RemoteSystemGroupCode: this.form.RemoteSystemGroupCode,
            RemoteSystemCode: 'FX',// this.form.RemoteSystemCode
            IsIntegral: this.form.isIntegral,
          };
          console.log(saveParams, "saveParams");
          groupSave(saveParams)
            .then((res) => {
              if (res.code == 200) {
                if (res.data.error.code == 2005) {
                  this.confirmFlag = true;
                  this.deleteFlag = false;
                  this.confirmMsg = res.data.error.message; //res.message
                  this.currentPage1 = 1;
                } else {
                  this.confirmFlag = true;
                  this.deleteFlag = false;
                  this.confirmMsg = "新增成功";
                  this.dialogFormVisible = false;
                  this.customSearch();
                  this.currentPage1 = 1;
                  this.form = {};
                }
              } else {
                this.confirmFlag = true;
                this.deleteFlag = false;
                this.confirmMsg = res.message; //res.message
                this.currentPage1 = 1;
              }
            })
            .catch(function (error) {
              console.log("新增失败", error.objError);
              this.customSearch();
            });

          // this.form = {};
        }
      });
    },
    // 修改保存
    async changeSave() {
      let saveParams = {
        id: this.changeRow.id,
        CName: this.changeForm.CName,
        EName: this.changeForm.EName,
        Code: this.changeForm.Code,
        RemoteSystemGroupCnName: this.changeForm.RemoteSystemGroupCnName,
        RemoteSystemGroupEnName: this.changeForm.RemoteSystemGroupEnName,
        RemoteSystemGroupCode: this.changeForm.RemoteSystemGroupCode,
        RemoteSystemCode: 'FX',//this.changeForm.RemoteSystemCode
        IsIntegral: this.changeForm.isIntegral,
      };
      console.log(saveParams, "修改保存参数");
      await groupSave(saveParams)
        .then((res) => {
          if (res.code == 200) {
            if (res.data.error.code == 2005) {
              this.confirmFlag = true;
              this.deleteFlag = false;
              this.confirmMsg = res.data.error.message;
            } else {
              this.confirmFlag = true;
              this.deleteFlag = false;
              this.confirmMsg = "修改成功";
              this.currentPage1 = 1;
              this.changeCountryFlag = false;
              this.customSearch();
            }
          } else {
            this.confirmFlag = true;
            this.deleteFlag = false;
            this.confirmMsg = res.message;
          }
        })
        .catch(function (error) {
          console.log("修改失败", error.objError);
        });
    },
    //修改button
    handleChange(row) {
      console.log(row);
      this.changeRow = row;
      this.changeCountryFlag = true;
      this.changeForm.id = this.changeRow.id;
      this.changeForm.CName = this.changeRow.cName;
      this.changeForm.EName = this.changeRow.eName;
      this.changeForm.Code = this.changeRow.code;
      this.changeForm.RemoteSystemCode = this.changeRow.remoteSystemCode;
      this.changeForm.RemoteSystemGroupCnName = this.changeRow.remoteSystemGroupCnName;
      this.changeForm.RemoteSystemGroupEnName = this.changeRow.remoteSystemGroupEnName;
      this.changeForm.RemoteSystemGroupCode = this.changeRow.remoteSystemGroupCode;
      this.changeForm.isIntegral = this.changeRow.isIntegral.toString();
    },
    //取消button
    cancel() {
      this.dialogFormVisible = false;
      this.changeCountryFlag = false;
      this.form.countryCode = "";
      this.form.nationEN = "";
      this.form.nationCH = "";
    },
    //删除dialog
    cancelDelete() {
      this.deletedialogVisible = false;
    },
    //删除
    deleteRow(row) {
      this.deletedialogVisible = true;
      this.deleteparams = {
        params: {
          id: row.id,
        },
      };
    },
    async confirmDelete() {
      this.deletedialogVisible = false;
      groupDelete(this.deleteparams)
        .then((res) => {
          if (res.code == 200) {
            this.confirmFlag = true;
            this.confirmMsg = "删除成功";
            this.customSearch();
            this.currentPage1 = 1;
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "删除失败";
          }
        })
        .catch(() => {
          console.log("删除请求失败");
        });
    },
    //搜索button
    async customSearch(int) {
      this.submitLoading = true;
      let searchparams = {
        params: {
          code: this.searchForm.code,
          page: int ? int : 1,
          pageSize: 10,
        },
      };
      await groupList(searchparams)
        .then((res) => {
          console.log(res);
          this.submitLoading = false;
          this.tableData = res.data.list;
          this.searchForm.total = res.data.total;
        })
        .catch(function (error) {
          this.submitLoading = false;
          console.log("请求失败", error.objError);
        });
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    Format(value, index) {
      if (index.property == "createdDate") {
        return formatDateTime(value.createdDate, "YYYY-MM-DD HH:mm:ss")
      }
      else if (index.property == "isIntegral") {
        return value.isIntegral ? "可积分" : "不可积分"
      }
    },
    uploadFile() {
      this.$refs.uploadFile.click();
    },
    fileValueChange() {
      this.submitLoading = true;
      // 选中文件后，会触发input的change事件，即会进入此函数
      var formData = new FormData();
      formData.append(
        "file",
        this.$refs.uploadFile.files[0],
        "harp mapping导入文件.csv"
      );
      var path = this.$refs.uploadFile.files[0].name;  //得到的是现在文件的路径
      var suffix = path.substr(path.lastIndexOf(".")).toUpperCase();//得到的是后缀名,且转换为大写
      if (suffix != ".CSV") {
        this.submitLoading = false;
        this.confirmFlag = true;
        this.confirmMsg = "上传失败，请检查是否为csv文件并重新上传";
        return;
      }
      this.loading = true;
      groupImport(formData)
        .then((res) => {
          this.submitLoading = false;
          if (res.code == 200) {
            this.confirmFlag = true;
            this.confirmMsg = this.$t("MESSAGE.HARPID");
            document.getElementById("import_btn").value = "";
          }
          //temp
          else if (res.code == 500) {
            this.confirmFlag = true;
            this.confirmMsg = "上传失败，请检查是否为csv文件并重新上传";
            //清空value值  解决无法上传相同名字文件的问题
            document.getElementById("import_btn").value = "";
          }
          this.customSearch();
        })
        .catch((e) => {
          this.submitLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "上传失败，请检查是否为csv文件并重新上传";
          document.getElementById("import_btn").value = "";
        });
    },
  },
};
</script>

<style scoped>
.paginationsty {
  float: right;
  margin: 1rem 0;
}

.pos_container_panel {
  padding: 0 16rem 4rem;
}

.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
</style>
